export default "__VITE_ASSET__66326677__"